import { render, staticRenderFns } from "./EditDatabaseLookup.vue?vue&type=template&id=04484860&"
import script from "./EditDatabaseLookup.vue?vue&type=script&lang=js&"
export * from "./EditDatabaseLookup.vue?vue&type=script&lang=js&"
import style0 from "./EditDatabaseLookup.vue?vue&type=style&index=0&id=04484860&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports